import React, { useEffect } from 'react';
import { useDispatch } from 'umi';
import { TasksList } from '@/pages/Tasks/TasksList';
import { LeadDetailsModel } from '@/typings/models/Lead';

export interface TasksDrawerProps {
  leadId: string;
  leadDetails: LeadDetailsModel;
  onRefresh?: () => void;
  payload?: { mode?: string; taskId?: string; [key: string]: any };
}

/**
 * Tasks drawer that displays tasks with create/edit capabilities
 * Reuses the existing TasksList component for consistency
 */
const TasksDrawer: React.FC<TasksDrawerProps> = ({
  leadDetails,
  onRefresh,
  leadId,
  payload
}) => {
  const dispatch = useDispatch();

  const handleRequest = () => {
    if (onRefresh) {
      onRefresh();
    }
  };

  // Auto-open edit task drawer when mode is 'edit' and taskId is provided
  useEffect(() => {
    if (payload?.mode === 'edit' && payload?.taskId && leadDetails) {
      const task = leadDetails.tasks?.find((t: any) => t.id === payload.taskId);
      if (task) {
        dispatch({
          type: 'leadTasks/openCreateTaskDrawer',
          payload: {
            task,
            leadId: leadDetails.id,
            onTaskCreated: handleRequest,
          },
        });
      }
    }
  }, [payload?.mode, payload?.taskId]);

  return (
    <TasksList
      leadId={leadId}
      request={handleRequest}
      data={leadDetails?.tasks || []}
    />
  );
};

export default TasksDrawer;
